// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Footer.css */
.footer {
    background-color: var(--white);
    padding: 24px;
    text-align: center;
    border-top: 1px solid var(--light-border);
  }`, "",{"version":3,"sources":["webpack://./src/components/css/Footer.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;IACI,8BAA8B;IAC9B,aAAa;IACb,kBAAkB;IAClB,yCAAyC;EAC3C","sourcesContent":["/* src/components/Footer.css */\n.footer {\n    background-color: var(--white);\n    padding: 24px;\n    text-align: center;\n    border-top: 1px solid var(--light-border);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
